<template>
  <div>
    <div class="ui divided items vuejs">
      <drive-upload-component
        v-for="upload in uploadsArray"
        :key="upload.file.token"
        v-bind="{ ...upload, parent: parent }"
        :success="upload.success"
        :file-extension="upload.fileExtension"
        @change="onChange"
        @input="emitFormData"
        @s3Key="emitS3Key($event, upload.file.token)"
        v-model="formData[upload.file.token]"
        @remove="() => removeUpload(upload.file.token)"
      ></drive-upload-component>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import {
  DriveInode,
  FormDataMap,
  DriveUpload,
} from "components/Drive/drive.types"
import DriveUploadComponent from "components/Drive/DriveUpload.vue"
export default defineComponent({
  name: "DriveUploaderForm",
  components: {
    DriveUploadComponent,
  },
  props: {
    uploadsArray: {
      type: Array as PropType<DriveUpload[]>,
      default: () => [],
    },
    parent: {
      type: Object as PropType<DriveInode>,
    },
  },
  data(): { formData: FormDataMap } {
    return {
      formData: {},
    }
  },
  methods: {
    onChange() {
      this.$emit("change")
    },
    emitFormData() {
      this.$emit("formData", this.formData)
    },
    removeUpload(token: string) {
      this.$emit("remove", token)
    },
    emitS3Key(s3Key: string, token: string) {
      this.$emit("s3Key", { s3Key, token })
    },
  },
  watch: {
    uploadsArray: {
      handler: function (val: DriveUpload[], oldVal) {
        const newFormData = {}
        for (const upload of val) {
          newFormData[upload.file.token] =
            this.formData[upload.file.token] || {}
        }
        this.formData = newFormData
      },
    },
  },
})
</script>
